import { render, staticRenderFns } from "./EventoPantalla.vue?vue&type=template&id=2267209e&"
import script from "./EventoPantalla.vue?vue&type=script&lang=ts&"
export * from "./EventoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports